import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f066f75a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/mediaLinks.scss?vue&type=style&index=0&id=f066f75a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f066f75a",
  null
  
)

export default component.exports